import { Button, Flex, Typography } from 'front-commons/ds';
import type { DistributorsActionButtonsProps } from './interfaces';

export function DistributorsActionButtons({
	leftButton,
	rightButton,
	textButton,
	...flexProps
}: DistributorsActionButtonsProps) {
	if (!leftButton && !rightButton && !textButton) return null;

	return (
		<Flex
			data-testid="distributors-action-buttons-container"
			data-button-quantity={[leftButton, rightButton, textButton].filter(Boolean).length}
			gap="16px"
			padding={{ small: '16px', medium: '16px 24px' }}
			borderRadius={{ medium: '8px' }}
			position="absolute"
			left="0px"
			right="0px"
			bottom="0px"
			direction={{ small: 'column', medium: 'row' }}
			width={{ small: 'calc(100% + 32px)', medium: 'fit-content' }}
			margin={{ small: '0 -16px', medium: '0' }}
			zIndex={15}
			backgroundColor="--surface-white"
			boxShadow="0px -4px 24px 0px var(--greys-1000-15)"
			{...flexProps}
		>
			{textButton && (
				<Button
					id="textButton"
					data-testid="text-button"
					variant="text"
					width={{ small: '100%', medium: 'fit-content' }}
					style={{ textDecorationLine: 'blink !important', color: 'var(--text-link)' }}
					{...textButton}
				>
					<Flex style={{ color: 'var(--text-blue)' }} as={Typography} variant="Paragraph/Underline">
						{textButton.children}
					</Flex>
				</Button>
			)}
			{leftButton && (
				<Button
					id="leftButton"
					data-position="left"
					data-testid="left-button"
					variant="secondary"
					width={{ small: '100%', medium: 'fit-content' }}
					{...leftButton}
				>
					{leftButton.children}
				</Button>
			)}
			{rightButton && (
				<Button
					data-position="right"
					data-testid="right-button"
					width={{ small: '100%', medium: 'fit-content' }}
					{...rightButton}
				>
					{rightButton.children}
				</Button>
			)}
		</Flex>
	);
}
